module.exports = __webpack_public_path__ + "static/media/cec_logo.d0af0727.png";